/**
 * Pre-Pour administration window, in hours. A pre-poured dose may be recorded as given only within
 * this many hours before or after its scheduled time (stakeholder feedback, 2026-09-15).
 * Platform-configurable later; the default is 1.
 */
export const PREPOUR_ADMIN_WINDOW_HOURS = 1;

/**
 * Longest pre-pour window, in days. Pouring further ahead than this is refused (stakeholder,
 * 2026-09-22): a caregiver fills an organizer a week or two out, not half a year.
 *
 * The number moves to remote configuration later — it is deliberately one named constant so that
 * becomes a one-line change. Joe floated "two or three weeks", then "you could get 90 days"; the
 * decision taken after the meeting is one month.
 *
 * Enforced on the client only for now. The prototype does not reach the backend at all, so there is
 * nothing to enforce it against yet; the same two rules (no past days, no further than this) have to
 * land server-side before pre-pour is anything but a prototype, or the endpoint can simply be called
 * directly with any range at all.
 */
export const PREPOUR_MAX_RANGE_DAYS = 31;
